import { cn } from '@/lib/utils'

type ButtonTone = 'pink' | 'yellow' | 'blue' | 'ink' | 'white'

const tones: Record<ButtonTone, string> = {
    pink: 'bg-pink text-ink',
    yellow: 'bg-sun text-ink',
    blue: 'bg-sky text-ink',
    ink: 'bg-ink text-white',
    white: 'bg-white text-ink'
}

/** The shared chunky button look: black outline and a hard offset shadow. */
export const buttonClass = (tone: ButtonTone = 'pink', className?: string) => cn(
    'inline-flex items-center justify-center gap-2 rounded-full border-2 border-line px-6 py-3 text-sm font-bold shadow-pop transition-transform duration-150 hover:-translate-y-0.5 active:translate-y-0.5 active:shadow-none disabled:pointer-events-none disabled:opacity-60',
    tones[tone],
    className
)

export const inputClass = 'w-full rounded-xl border-2 border-line bg-card px-4 py-3 text-base text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-grape/40 aria-invalid:border-destructive'

export const labelClass = 'mb-1.5 block text-sm font-semibold'

export const cardClass = 'rounded-2xl border-2 border-line bg-card shadow-pop'
